import {wrap} from "svelte-spa-router/wrap";
import Login from "./routes/security/Login.svelte";
import OrderAdd from "./routes/order/OrderAdd.svelte";
import OrderBrowse from "./routes/order/OrderBrowse.svelte";
import UserEdit from "./routes/user/UserEdit.svelte";
import UserAdd from "./routes/user/UserAdd.svelte";
import Reset from "./routes/password/Reset.svelte";
import Error404 from "./routes/exception/Error404.svelte";
import Error500 from "./routes/exception/Error500.svelte";
import Error401 from "./routes/exception/Error401.svelte";
import DocumentBrowse from "./routes/document/DocumentBrowse.svelte";
import {authentication, notLoggedInCheck} from "./security/authGuard";

const routes = {
    "/": wrap({
        component: Login,
        conditions: [
            () => {
                return notLoggedInCheck();
            }
        ]
    }),
    "/commande/ajout":  wrap({
        component: OrderAdd,
        conditions: [
            async():Promise<boolean> => {
                return await authentication();
            }
        ]
    }),
    "/compte/commande":  wrap({
        component: OrderBrowse,
        conditions: [
            async():Promise<boolean> => {
                return await authentication();
            }
        ]
    }),
    "/compte/profil/modification": wrap({
        component: UserEdit,
        conditions: [
            async():Promise<boolean> => {
                return await authentication();
            }
        ]
    }),
    "/compte/demande-creation": wrap({
        component: UserAdd,
        conditions: [
            async():Promise<boolean> => {
                return notLoggedInCheck();
            }
        ]
    }),
    "/compte/mot-de-passe": wrap({
        component: Reset,
        conditions: [
            async():Promise<boolean> => {
                return notLoggedInCheck();
            }
        ]
    }),
    "/documentations": wrap({
        component: DocumentBrowse,
        conditions: [
            async():Promise<boolean> => {
                return await authentication();
            }
        ]
    }),
    "/erreur401": Error401,
    "/erreur500": Error500,
    "*": Error404
}
export {routes};
